(() => {

// Header dropdown navigation
function $062f626b3c756f24$export$58b91692c4753586() {
    const nav = document.getElementById('site-navigation');
    if (!nav) return;
    const closeAll = ()=>{
        nav.querySelectorAll('.menu-item-has-children.is-open').forEach((el)=>{
            el.classList.remove('is-open');
        });
    };
    nav.addEventListener('click', (e)=>{
        const link = e.target.closest('.menu-item-has-children > a');
        if (!link) return;
        e.preventDefault();
        const li = link.closest('li');
        const isOpen = li.classList.contains('is-open');
        closeAll();
        if (!isOpen) li.classList.add('is-open');
    });
    document.addEventListener('click', (e)=>{
        if (!nav.contains(e.target)) nav.querySelectorAll('.menu-item-has-children.is-open').forEach((el)=>{
            el.classList.remove('is-open');
        });
    });
}
function $062f626b3c756f24$export$11832047a21ac95e() {
    const header = document.getElementById('site-header');
    if (!header) {
        console.error('Header not found!');
        return;
    }
    // Create a sentinel element at the top of the page
    const sentinel = document.createElement('div');
    sentinel.className = 'scroll-sentinel';
    sentinel.style.position = 'absolute';
    sentinel.style.top = '50px';
    sentinel.style.width = '1px';
    sentinel.style.height = '1px';
    sentinel.style.pointerEvents = 'none';
    document.body.appendChild(sentinel);
    // Create Intersection Observer
    const observerOptions = {
        rootMargin: '0px',
        threshold: 0
    };
    const observerCallback = (entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) // Sentinel is out of view (scrolled past 50px)
            header.classList.add('scrolled');
            else // Sentinel is in view (at top of page)
            header.classList.remove('scrolled');
        });
    };
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(sentinel);
}


function $a02122651b081db3$export$fcd45dffdaea0ebb() {
    document.addEventListener('click', function(e) {
        if (!e.target.classList.contains('buy-now-btn')) return;
        e.preventDefault();
        const button = e.target;
        const variationId = button.getAttribute('data-variation-id');
        const nonce = button.getAttribute('data-nonce');
        if (!variationId || !nonce) {
            alert('Invalid product data. Please refresh the page and try again.');
            return;
        }
        button.disabled = true;
        const originalText = button.textContent;
        button.textContent = 'Processing...';
        const formData = new FormData();
        formData.append('action', 'wpbuoy_buy_now');
        formData.append('variation_id', variationId);
        formData.append('nonce', nonce);
        fetch(wpbuoy_ajax.ajax_url, {
            method: 'POST',
            body: formData
        }).then((response)=>response.json()).then((data)=>{
            if (data.success) window.location.href = data.data.redirect_url;
            else {
                alert(data.data.message || 'An error occurred. Please try again.');
                button.disabled = false;
                button.textContent = originalText;
            }
        }).catch(()=>{
            alert('A network error occurred. Please try again.');
            button.disabled = false;
            button.textContent = originalText;
        });
    });
}


// showSuccess('Operation completed!');
// showError('Something went wrong!');
// showWarning('Please check your input');
// showInfo('Here\'s some information');
window.wpbuoy = window.wpbuoy || {};
window.wpbuoy.notification = window.wpbuoy.notification || {};
let $1f15f99c0f3b64e4$var$notificationContainer = null;
let $1f15f99c0f3b64e4$var$notificationCounter = 0;
// Initialize the notification container
function $1f15f99c0f3b64e4$var$initNotificationContainer() {
    if ($1f15f99c0f3b64e4$var$notificationContainer) return;
    $1f15f99c0f3b64e4$var$notificationContainer = document.createElement('div');
    $1f15f99c0f3b64e4$var$notificationContainer.className = 'notification-container';
    document.body.appendChild($1f15f99c0f3b64e4$var$notificationContainer);
}
function $1f15f99c0f3b64e4$export$f7dc72e91f29c7d7(message, type = 'info', duration = 5000) {
    $1f15f99c0f3b64e4$var$initNotificationContainer();
    const notification = document.createElement('div');
    const notificationId = `notification-${++$1f15f99c0f3b64e4$var$notificationCounter}`;
    notification.id = notificationId;
    notification.className = `notification notification-${type}`;
    notification.innerHTML = `
    <div class="notification-inner">
      <span>${message}</span>
      <button type="button">&times;</button>
    </div>
  `;
    $1f15f99c0f3b64e4$var$notificationContainer.appendChild(notification);
    setTimeout(()=>{
        notification.style.transform = 'translateX(0)';
    }, 10);
    // Close functionality
    const closeBtn = notification.querySelector('button');
    const closeNotification = ()=>{
        notification.style.transform = 'translateX(100%)';
        notification.style.opacity = '0';
        setTimeout(()=>{
            if (notification.parentNode) notification.parentNode.removeChild(notification);
        }, 300);
    };
    closeBtn.addEventListener('click', closeNotification);
    notification.addEventListener('click', closeNotification);
    if (duration > 0) setTimeout(closeNotification, duration);
    return notificationId;
}
function $1f15f99c0f3b64e4$export$d841eba85c078f0b(message, duration = 5000) {
    return $1f15f99c0f3b64e4$export$f7dc72e91f29c7d7(message, 'success', duration);
}
function $1f15f99c0f3b64e4$export$3879b24e8245693d(message, duration = 7000) {
    return $1f15f99c0f3b64e4$export$f7dc72e91f29c7d7(message, 'error', duration);
}
function $1f15f99c0f3b64e4$export$da2f4e8190fdb5e1(message, duration = 6000) {
    return $1f15f99c0f3b64e4$export$f7dc72e91f29c7d7(message, 'warning', duration);
}
function $1f15f99c0f3b64e4$export$3ddc711ac21275cd(message, duration = 5000) {
    return $1f15f99c0f3b64e4$export$f7dc72e91f29c7d7(message, 'info', duration);
}
function $1f15f99c0f3b64e4$export$2548e031fd6cf38a() {
    if (!$1f15f99c0f3b64e4$var$notificationContainer) return;
    const notifications = $1f15f99c0f3b64e4$var$notificationContainer.querySelectorAll('.notification');
    notifications.forEach((notification)=>{
        notification.style.transform = 'translateX(100%)';
        notification.style.opacity = '0';
    });
    setTimeout(()=>{
        if ($1f15f99c0f3b64e4$var$notificationContainer) $1f15f99c0f3b64e4$var$notificationContainer.innerHTML = '';
    }, 300);
}
function $1f15f99c0f3b64e4$export$92eb0ea44f8c9242(notificationId) {
    const notification = document.getElementById(notificationId);
    if (notification) {
        notification.style.transform = 'translateX(100%)';
        notification.style.opacity = '0';
        setTimeout(()=>{
            if (notification.parentNode) notification.parentNode.removeChild(notification);
        }, 300);
    }
}


window.wpbuoy = window.wpbuoy || {};
window.wpbuoy.login = window.wpbuoy.login || {};
window.wpbuoy.login.submit = function(e) {
    e.preventDefault();
    const form = e.target;
    const username = form.querySelector('[name="username"]');
    const password = form.querySelector('[name="password"]');
    const remember = form.querySelector('[name="rememberme"]:checked');
    const redirect = form.querySelector('[name="redirect"]');
    const nonce = form.querySelector('[name="nonce"]');
    const submit = form.querySelector('[type="submit"]');
    const formData = new FormData();
    submit.classList.add('loading');
    submit.disabled = true;
    formData.append('action', 'wpbuoy_login');
    formData.append('username', username.value);
    formData.append('password', password.value);
    formData.append('remember', remember ? 1 : 0);
    formData.append('nonce', nonce.value);
    fetch(wpbuoy_ajax.ajax_url, {
        method: 'POST',
        body: formData
    }).then((response)=>response.json()).then((data)=>{
        if (data.success) window.location.href = redirect.value;
        else (0, $1f15f99c0f3b64e4$export$3879b24e8245693d)(data.data.message);
    }).catch((error)=>{
        (0, $1f15f99c0f3b64e4$export$3879b24e8245693d)('An error occurred. Please try again.');
    }).finally(()=>{
        submit.classList.remove('loading');
        submit.disabled = false;
    });
};
window.wpbuoy.login.eventListeners = function() {
    const loginForms = document.querySelectorAll('.wpbuoy-login-form');
    loginForms.forEach((form)=>{
        form.addEventListener('submit', window.wpbuoy.login.submit);
    });
};
window.wpbuoy.login.eventListeners();


document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('[data-account-forms]');
    if (!wrapper) return;
    const panels = wrapper.querySelectorAll('[data-account-panel]');
    function showPanel(name) {
        let matched = false;
        panels.forEach((panel)=>{
            if (panel.dataset.accountPanel === name) {
                panel.classList.remove('hidden');
                matched = true;
            } else panel.classList.add('hidden');
        });
        return matched;
    }
    wrapper.querySelectorAll('[data-account-switch]').forEach((link)=>{
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const target = this.dataset.accountSwitch;
            showPanel(target);
            history.replaceState(null, '', '#' + target);
        });
    });
    function showPanelFromHash() {
        const hash = window.location.hash.replace('#', '');
        if (hash) showPanel(hash);
    }
    showPanelFromHash();
    window.addEventListener('hashchange', showPanelFromHash);
});


function $c0b12ee645bf5a4a$var$addToCart(e) {
    e.preventDefault();
    const productId = this.dataset.productId;
    const formData = new FormData();
    this.classList.add('loading');
    this.disabled = true;
    formData.append('action', 'add_to_cart_ajax');
    formData.append('product_id', productId);
    formData.append('quantity', 1);
    formData.append('nonce', wpbuoy_ajax.nonce);
    fetch(wpbuoy_ajax.ajax_url, {
        method: 'POST',
        body: formData
    }).then((response)=>response.json()).then((data)=>{
        this.classList.remove('loading');
        this.disabled = false;
        if (data.success) {
            // Update cart counter
            const cartCounter = document.querySelector('.cart-counter');
            if (cartCounter && data.data.cart_count !== undefined) {
                cartCounter.setAttribute('data-count', data.data.cart_count);
                cartCounter.textContent = data.data.cart_count > 0 ? data.data.cart_count : '';
                // Add shake animation
                cartCounter.classList.add('shake');
                // Remove shake class after animation completes
                setTimeout(()=>{
                    cartCounter.classList.remove('shake');
                }, 1000);
            }
        } else console.error('Error:', data.message);
    }).catch((error)=>{
        this.classList.remove('loading');
        this.disabled = false;
        console.error('Error:', error);
    });
}
const $c0b12ee645bf5a4a$var$addToCarts = document.querySelectorAll('.add-to-cart');
if ($c0b12ee645bf5a4a$var$addToCarts) $c0b12ee645bf5a4a$var$addToCarts.forEach((addToCart)=>{
    addToCart.addEventListener('click', addToCart);
});


document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('modal-show')) {
            e.preventDefault();
            const targetId = e.target.dataset.targetId;
            document.getElementById(targetId)?.classList.add('show');
        }
        if (e.target.classList.contains('modal-close') || e.target.classList.contains('modal-overlay')) {
            const modal = e.target.closest('.modal') || e.target;
            modal.classList.remove('show');
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
    const faqSection = document.getElementById('faqs');
    if (!faqSection) return;
    const questions = faqSection.querySelectorAll('.question');
    const searchInput = document.getElementById('faq-search');
    const faqs = faqSection.querySelectorAll('.faq');
    const faqList = document.getElementById('faq-list');
    // FAQ toggle functionality
    if (questions.length > 0) questions.forEach((question)=>{
        question.addEventListener('click', function() {
            const faq = this.parentElement;
            if (!faq.classList.contains('active')) {
                faqs.forEach((f)=>{
                    f.classList.remove('active');
                });
                faq.classList.add('active');
            } else faq.classList.remove('active');
        });
    });
    // FAQ search functionality
    if (searchInput && faqs.length > 0 && faqList) searchInput.addEventListener('input', function() {
        const searchTerm = this.value.toLowerCase().trim();
        let hasVisibleFaqs = false;
        faqs.forEach((faq)=>{
            const question = faq.querySelector('.question');
            const questionTextSpan = faq.querySelector('.question-text');
            if (!question || !questionTextSpan) return;
            // Store original text if not already stored
            if (!questionTextSpan.dataset.originalText) questionTextSpan.dataset.originalText = questionTextSpan.textContent.trim();
            const questionText = questionTextSpan.dataset.originalText.toLowerCase();
            // Check if search term matches question only
            if (searchTerm === '' || questionText.includes(searchTerm)) {
                faq.style.display = '';
                hasVisibleFaqs = true;
                // Highlight matching text
                if (searchTerm !== '') {
                    const regex = new RegExp(`(${searchTerm})`, 'gi');
                    const highlightedText = questionTextSpan.dataset.originalText.replace(regex, '<mark class="bg-yellow-400 text-black">$1</mark>');
                    questionTextSpan.innerHTML = highlightedText;
                } else // Restore original text
                questionTextSpan.textContent = questionTextSpan.dataset.originalText;
            } else faq.style.display = 'none';
        });
        // Show "no results" message if no FAQs are visible
        let noResultsMsg = document.getElementById('faq-no-results');
        if (!hasVisibleFaqs && searchTerm !== '') {
            if (!noResultsMsg) {
                noResultsMsg = document.createElement('p');
                noResultsMsg.id = 'faq-no-results';
                noResultsMsg.className = 'text-center text-white/70 mt-8';
                noResultsMsg.textContent = 'No FAQs found matching your search.';
                faqList.appendChild(noResultsMsg);
            }
            noResultsMsg.style.display = 'block';
        } else if (noResultsMsg) noResultsMsg.style.display = 'none';
    });
});



window.wpbuoy = window.wpbuoy || {};
window.wpbuoy.contact = window.wpbuoy.contact || {};
window.wpbuoy.contact.submit = function(e) {
    e.preventDefault();
    const form = document.getElementById('wpcf7-f6-p84-o1');
    const submit = form.querySelector('[type="submit"]');
    submit.classList.add('loading');
    submit.disabled = true;
};
window.wpbuoy.contact.showErrors = function(event) {
    if (event.detail.apiResponse.status === 'validation_failed') {
        const form = document.getElementById('wpcf7-f6-p84-o1');
        const submit = form.querySelector('[type="submit"]');
        submit.classList.remove('loading');
        submit.disabled = false;
        (0, $1f15f99c0f3b64e4$export$3879b24e8245693d)(event.detail.apiResponse.message);
    }
};
window.wpbuoy.contact.showSuccess = function(event) {
    if (event.detail.apiResponse.status === 'mail_sent') {
        const forms = document.querySelectorAll('.wpcf7-form');
        forms.forEach((form)=>{
            const submit = form.querySelector('[type="submit"]');
            form.reset();
            submit.classList.remove('loading');
            submit.disabled = false;
        });
        (0, $1f15f99c0f3b64e4$export$d841eba85c078f0b)(event.detail.apiResponse.message);
    }
};
window.wpbuoy.contact.eventListeners = function() {
    const form = document.getElementById('wpcf7-f6-p84-o1');
    if (form) {
        form.addEventListener('submit', window.wpbuoy.contact.submit);
        document.addEventListener('wpcf7mailsent', window.wpbuoy.contact.showSuccess);
        document.addEventListener('wpcf7invalid', window.wpbuoy.contact.showErrors);
    }
};
window.wpbuoy.contact.initSubjectSelect = function() {
    if (typeof jQuery === 'undefined' || !jQuery.fn.selectWoo) return;
    jQuery('select[name="subject"]').selectWoo({
        minimumResultsForSearch: Infinity,
        width: '100%'
    });
};
window.wpbuoy.contact.eventListeners();
window.addEventListener('load', window.wpbuoy.contact.initSubjectSelect);


// Shared password strength/match criteria — used by both the checkout
// account-signup form and the /account registration form, so the rules
// and the live checklist behavior stay identical in both places.
const $967a8b4abf1d000f$export$c1047c16db53910f = [
    {
        attr: 'length',
        test: (v, _)=>v.length >= 8
    },
    {
        attr: 'uppercase',
        test: (v, _)=>/[A-Z]/.test(v)
    },
    {
        attr: 'lowercase',
        test: (v, _)=>/[a-z]/.test(v)
    },
    {
        attr: 'number',
        test: (v, _)=>/[0-9]/.test(v)
    },
    {
        attr: 'special',
        test: (v, _)=>/[^A-Za-z0-9]/.test(v)
    },
    {
        attr: 'match',
        test: (v, c)=>v.length > 0 && v === c
    }
];
function $967a8b4abf1d000f$export$8dc66c8778e5fc1(scope = document) {
    scope.querySelectorAll('[data-rule]').forEach((li)=>{
        if (li.querySelector('.criteria-icon')) return;
        const icon = document.createElement('span');
        icon.className = 'material-icons-outlined criteria-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = 'radio_button_unchecked';
        li.prepend(icon);
    });
}
function $967a8b4abf1d000f$export$ce56cc4027499cbd(passwordField, confirmField, scope = document) {
    const value = passwordField.value;
    const confirm = confirmField ? confirmField.value : '';
    $967a8b4abf1d000f$export$c1047c16db53910f.forEach(({ attr: attr, test: test })=>{
        const li = scope.querySelector(`[data-rule="${attr}"]`);
        if (!li) return;
        const icon = li.querySelector('.criteria-icon');
        const met = test(value, confirm);
        li.classList.toggle('criteria-met', met);
        if (icon) icon.textContent = met ? 'check_circle' : 'radio_button_unchecked';
    });
}


window.wpbuoy = window.wpbuoy || {};
window.wpbuoy.checkoutPassword = window.wpbuoy.checkoutPassword || {};
// --- Password criteria rules ---
// Shared with the /account registration form — see password-criteria.js.
function $a577d8d2e81f93bb$var$evaluate(passwordField, confirmField) {
    (0, $967a8b4abf1d000f$export$ce56cc4027499cbd)(passwordField, confirmField);
}
// --- Loader ---
function $a577d8d2e81f93bb$var$showLoader(container) {
    if (!container || container.querySelector('.wpbuoy-loader')) return;
    const loader = document.createElement('div');
    loader.className = 'wpbuoy-loader';
    container.appendChild(loader);
}
function $a577d8d2e81f93bb$var$hideLoader(container) {
    if (!container) return;
    const loader = container.querySelector('.wpbuoy-loader');
    if (loader) loader.remove();
}
// --- Order details gate ---
function $a577d8d2e81f93bb$var$updateOrderDetails() {
    const payment = document.querySelector('.ppc-button-wrapper');
    if (!payment) return;
    // Standard billing fields only (inside the field wrapper, excludes our custom account section)
    const billingFields = document.querySelectorAll('.woocommerce-billing-fields__field-wrapper input[aria-required="true"], .woocommerce-billing-fields__field-wrapper select[aria-required="true"]');
    const billingFilled = billingFields.length > 0 && Array.from(billingFields).every((f)=>f.value.trim() !== '');
    const accountSection = document.getElementById('wpbuoy-account-section');
    const sectionVisible = accountSection && accountSection.style.display !== 'none';
    let accountFilled = true;
    if (sectionVisible) {
        const signupForm = document.getElementById('wpbuoy-signup-form');
        const loginForm = document.getElementById('wpbuoy-inline-login-form');
        const signupActive = signupForm && signupForm.style.display !== 'none';
        const loginActive = loginForm && loginForm.style.display !== 'none';
        if (signupActive) {
            const criteriaItems = document.querySelectorAll('[data-rule]');
            accountFilled = criteriaItems.length > 0 && Array.from(criteriaItems).every((li)=>li.classList.contains('criteria-met'));
        } else if (loginActive) accountFilled = false;
    }
    payment.classList.toggle('enabled', billingFilled && accountFilled);
}
// --- Account section state ---
const $a577d8d2e81f93bb$var$copy = {
    signup: 'No account found for this email \u2014 create a password to continue.',
    login: 'An account already exists for this email \u2014 enter your password below to continue.'
};
function $a577d8d2e81f93bb$var$showSection() {
    const section = document.getElementById('wpbuoy-account-section');
    if (section) section.style.display = '';
    $a577d8d2e81f93bb$var$updateOrderDetails();
}
function $a577d8d2e81f93bb$var$showSignup() {
    const subtext = document.getElementById('wpbuoy-account-subtext');
    const signup = document.getElementById('wpbuoy-signup-form');
    const login = document.getElementById('wpbuoy-inline-login-form');
    if (subtext) subtext.textContent = $a577d8d2e81f93bb$var$copy.signup;
    if (signup) signup.style.display = '';
    if (login) login.style.display = 'none';
    $a577d8d2e81f93bb$var$showSection();
}
function $a577d8d2e81f93bb$var$showLogin(email) {
    const subtext = document.getElementById('wpbuoy-account-subtext');
    const signup = document.getElementById('wpbuoy-signup-form');
    const login = document.getElementById('wpbuoy-inline-login-form');
    const emailInput = document.getElementById('wpbuoy-login-email');
    if (subtext) subtext.textContent = $a577d8d2e81f93bb$var$copy.login;
    if (signup) signup.style.display = 'none';
    if (login) login.style.display = '';
    if (emailInput) emailInput.value = email || '';
    $a577d8d2e81f93bb$var$showSection();
}
// --- Email check ---
let $a577d8d2e81f93bb$var$lastCheckedEmail = '';
function $a577d8d2e81f93bb$var$checkEmail(email) {
    const section = document.getElementById('wpbuoy-account-section');
    const nonce = document.getElementById('wpbuoy-check-email-nonce');
    if (!section || !nonce) return;
    $a577d8d2e81f93bb$var$showLoader(section);
    const body = new FormData();
    body.append('action', 'wpbuoy_check_email');
    body.append('email', email);
    body.append('nonce', nonce.value);
    fetch(wpbuoy_ajax.ajax_url, {
        method: 'POST',
        body: body
    }).then((r)=>r.json()).then((data)=>{
        if (!data.success) return;
        data.data.exists ? $a577d8d2e81f93bb$var$showLogin(email) : $a577d8d2e81f93bb$var$showSignup();
    }).finally(()=>$a577d8d2e81f93bb$var$hideLoader(section));
}
// --- Inline login (auto-fires on password blur) ---
function $a577d8d2e81f93bb$var$handleInlineLogin() {
    const section = document.getElementById('wpbuoy-account-section');
    const loginWrap = document.getElementById('wpbuoy-inline-login-form');
    const passInput = document.getElementById('wpbuoy-login-password');
    const nonce = document.getElementById('wpbuoy-login-nonce');
    const redirect = document.getElementById('wpbuoy-login-redirect');
    const errorEl = loginWrap ? loginWrap.querySelector('.wpbuoy-login-error') : null;
    const email = document.querySelector('#billing_email') ? document.querySelector('#billing_email').value.trim() : '';
    if (!passInput.value) return;
    if (errorEl) errorEl.style.display = 'none';
    $a577d8d2e81f93bb$var$showLoader(section);
    const body = new FormData();
    body.append('action', 'wpbuoy_login');
    body.append('username', email);
    body.append('password', passInput.value);
    body.append('rememberme', 0);
    body.append('nonce', nonce.value);
    fetch(wpbuoy_ajax.ajax_url, {
        method: 'POST',
        body: body
    }).then((r)=>r.json()).then((data)=>{
        if (data.success) window.location.href = redirect ? redirect.value : window.location.href;
        else {
            $a577d8d2e81f93bb$var$hideLoader(section);
            if (errorEl) {
                errorEl.textContent = data.data.message;
                errorEl.style.display = '';
            }
        }
    }).catch(()=>$a577d8d2e81f93bb$var$hideLoader(section));
}
// --- Init ---
window.wpbuoy.checkoutPassword.init = function() {
    const passwordField = document.querySelector('#account_password');
    const confirmField = document.querySelector('#account_password_confirm');
    const billingEmail = document.querySelector('#billing_email');
    const loginPassword = document.getElementById('wpbuoy-login-password');
    // Inject criteria icons
    if (passwordField) {
        (0, $967a8b4abf1d000f$export$8dc66c8778e5fc1)();
        passwordField.addEventListener('input', ()=>{
            $a577d8d2e81f93bb$var$evaluate(passwordField, confirmField);
            $a577d8d2e81f93bb$var$updateOrderDetails();
        });
        if (confirmField) {
            confirmField.addEventListener('input', ()=>{
                $a577d8d2e81f93bb$var$evaluate(passwordField, confirmField);
                $a577d8d2e81f93bb$var$updateOrderDetails();
            });
            passwordField.addEventListener('keydown', (e)=>{
                if (e.key === 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    confirmField.focus();
                }
            });
        }
    }
    // Email check
    if (billingEmail) {
        billingEmail.addEventListener('blur', function() {
            const email = this.value.trim();
            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
            if (email === $a577d8d2e81f93bb$var$lastCheckedEmail) return;
            $a577d8d2e81f93bb$var$lastCheckedEmail = email;
            $a577d8d2e81f93bb$var$checkEmail(email);
        });
        // On load: if email is already populated (session/autofill), check immediately
        const prefilledEmail = billingEmail.value.trim();
        if (prefilledEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(prefilledEmail)) {
            $a577d8d2e81f93bb$var$lastCheckedEmail = prefilledEmail;
            $a577d8d2e81f93bb$var$checkEmail(prefilledEmail);
        }
    }
    // Auto-login on password blur
    if (loginPassword) loginPassword.addEventListener('blur', $a577d8d2e81f93bb$var$handleInlineLogin);
    // Order details gate — watch all required billing fields
    const billingRequired = document.querySelectorAll('.woocommerce-billing-fields__field-wrapper input[aria-required="true"], .woocommerce-billing-fields__field-wrapper select[aria-required="true"]');
    billingRequired.forEach((field)=>{
        field.addEventListener('input', $a577d8d2e81f93bb$var$updateOrderDetails);
        field.addEventListener('change', $a577d8d2e81f93bb$var$updateOrderDetails);
    });
    if (wpbuoy_ajax.is_logged_in) {
        const payment = document.querySelector('.ppc-button-wrapper');
        if (payment) payment.classList.add('enabled');
    } else $a577d8d2e81f93bb$var$updateOrderDetails();
};
document.addEventListener('DOMContentLoaded', window.wpbuoy.checkoutPassword.init);


// Password criteria checklist for the /account registration form.
// Same rules/behavior as checkout — see password-criteria.js.

function $8be29cf96272a25a$var$init() {
    const passwordField = document.querySelector('#reg_password');
    const confirmField = document.querySelector('#reg_password_confirm');
    if (!passwordField) return;
    (0, $967a8b4abf1d000f$export$8dc66c8778e5fc1)();
    const evaluate = ()=>(0, $967a8b4abf1d000f$export$ce56cc4027499cbd)(passwordField, confirmField);
    passwordField.addEventListener('input', evaluate);
    if (confirmField) confirmField.addEventListener('input', evaluate);
}
document.addEventListener('DOMContentLoaded', $8be29cf96272a25a$var$init);


/**
 * Scroll the highlighted order row into view when arriving from a deeplink.
 * The row gains .order--highlighted if ?order_id= in the URL matches its data-order-id.
 */ document.addEventListener('DOMContentLoaded', function() {
    const row = document.querySelector('.order--highlighted');
    if (row) row.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
    });
});


document.addEventListener('DOMContentLoaded', function() {
    const article = document.querySelector('body.single-post article, body.page-template-product-knowledge-base article, body.page-template-product-highlights article');
    if (!article) return;
    article.querySelectorAll('pre').forEach(function(pre) {
        const btn = document.createElement('button');
        btn.className = 'copy-code-btn';
        btn.setAttribute('aria-label', 'Copy code');
        btn.innerHTML = '<span class="material-icons-outlined">content_copy</span>';
        btn.addEventListener('click', function() {
            const source = pre.querySelector('code') ? pre.querySelector('code').innerText : pre.innerText;
            navigator.clipboard.writeText(source).then(function() {
                btn.innerHTML = '<span class="material-icons-outlined">check</span>';
                btn.classList.add('copied');
                setTimeout(function() {
                    btn.innerHTML = '<span class="material-icons-outlined">content_copy</span>';
                    btn.classList.remove('copied');
                }, 2000);
            });
        });
        const wrapper = document.createElement('div');
        wrapper.className = 'code-block';
        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);
        wrapper.appendChild(btn);
    });
});



window.wpbuoy = window.wpbuoy || {};
window.wpbuoy.support = window.wpbuoy.support || {};
function $22506c6fcb276b00$var$getForm() {
    return document.querySelector('[id^="wpcf7-f1839"]');
}
function $22506c6fcb276b00$var$populateUserFields() {
    const userData = window.wpbuoyCurrentUser;
    if (!userData) return;
    const form = $22506c6fcb276b00$var$getForm();
    if (!form) return;
    const map = {
        'your-first-name': userData.firstName,
        'your-last-name': userData.lastName,
        'your-email': userData.email
    };
    Object.keys(map).forEach(function(name) {
        const el = form.querySelector('input[name="' + name + '"]');
        if (el) el.value = map[name];
    });
}
window.wpbuoy.support.submit = function(e) {
    const form = $22506c6fcb276b00$var$getForm();
    if (!form) return;
    const submit = form.querySelector('[type="submit"]');
    submit.classList.add('loading');
    submit.disabled = true;
};
window.wpbuoy.support.showErrors = function(event) {
    if (event.detail.apiResponse.status === 'validation_failed') {
        const form = $22506c6fcb276b00$var$getForm();
        if (!form) return;
        const submit = form.querySelector('[type="submit"]');
        submit.classList.remove('loading');
        submit.disabled = false;
        (0, $1f15f99c0f3b64e4$export$3879b24e8245693d)(event.detail.apiResponse.message);
    }
};
window.wpbuoy.support.showSuccess = function(event) {
    if (event.detail.apiResponse.status === 'mail_sent') {
        const form = $22506c6fcb276b00$var$getForm();
        if (!form) return;
        const submit = form.querySelector('[type="submit"]');
        form.reset();
        $22506c6fcb276b00$var$populateUserFields();
        submit.classList.remove('loading');
        submit.disabled = false;
        (0, $1f15f99c0f3b64e4$export$d841eba85c078f0b)(event.detail.apiResponse.message);
    }
};
window.wpbuoy.support.eventListeners = function() {
    const form = $22506c6fcb276b00$var$getForm();
    if (!form) return;
    $22506c6fcb276b00$var$populateUserFields();
    form.addEventListener('submit', window.wpbuoy.support.submit);
    document.addEventListener('wpcf7mailsent', window.wpbuoy.support.showSuccess);
    document.addEventListener('wpcf7invalid', window.wpbuoy.support.showErrors);
};
window.wpbuoy.support.eventListeners();


window.wpbuoy = {};
var $f9ccc1fa0d22629a$var$canvas = document.querySelector('#hero canvas');
if ($f9ccc1fa0d22629a$var$canvas) {
    var $f9ccc1fa0d22629a$var$context = $f9ccc1fa0d22629a$var$canvas.getContext('2d');
    var $f9ccc1fa0d22629a$var$bubbles = [];
    $f9ccc1fa0d22629a$var$canvas.width = screen.width;
    $f9ccc1fa0d22629a$var$canvas.height = screen.height;
    for(i = 0; i < 150; i++){
        let diameter = Math.ceil(Math.random() * 7);
        let radius = diameter / 2;
        let opacity = diameter * .035;
        let speed = diameter * .3;
        let x = Math.round(Math.floor(Math.random() * 100 + 0) * screen.width) / 100;
        let y = Math.round(Math.floor(Math.random() * 110 + 90) * screen.height) / 100;
        let amplitude = Math.random() * .3 + .3;
        $f9ccc1fa0d22629a$var$bubbles.push({
            amplitude: amplitude,
            radius: radius,
            opacity: opacity,
            speed: speed,
            x: x,
            y: y,
            initialX: x,
            initialY: y
        });
    }
    function animateParticles() {
        requestAnimationFrame(animateParticles);
        $f9ccc1fa0d22629a$var$context.clearRect(0, 0, innerWidth, innerHeight);
        for(let i1 = 0; i1 < $f9ccc1fa0d22629a$var$bubbles.length; i1++){
            let bubble = $f9ccc1fa0d22629a$var$bubbles[i1];
            if (bubble.y < 0) {
                bubble.x = bubble.initialX;
                bubble.y = bubble.initialY;
            }
            $f9ccc1fa0d22629a$var$context.beginPath();
            $f9ccc1fa0d22629a$var$context.arc(bubble.x, bubble.y, bubble.radius, 0, 2 * Math.PI);
            $f9ccc1fa0d22629a$var$context.closePath();
            $f9ccc1fa0d22629a$var$context.stroke();
            $f9ccc1fa0d22629a$var$context.strokeStyle = 'rgba(255, 255, 255, ' + bubble.opacity + ')';
            bubble.y += document.documentElement.scrollTop == 0 ? -bubble.speed : -bubble.speed * (document.documentElement.scrollTop / 100);
            bubble.x = bubble.x + Math.sin(i1 / bubble.amplitude) * .3;
        }
    }
    animateParticles();
}
// Initialize header scroll effects with Intersection Observer
document.addEventListener('DOMContentLoaded', function() {
    (0, $062f626b3c756f24$export$11832047a21ac95e)();
    (0, $062f626b3c756f24$export$58b91692c4753586)();
    (0, $a02122651b081db3$export$fcd45dffdaea0ebb)();
});

})();
//# sourceMappingURL=index.js.map
